/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { InsertCuepointYoutubeIntegrationCuepointsMutationRequest, InsertCuepointYoutubeIntegrationCuepointsMutationResponse, InsertCuepointYoutubeIntegrationCuepointsPathParams } from "../models/InsertCuepointYoutubeIntegrationCuepoints";

export function getInsertCuepointYoutubeIntegrationCuepointsUrl(station: InsertCuepointYoutubeIntegrationCuepointsPathParams["station"]) {
  const res = { method: 'POST', url: `/youtube-cuepoints/${station}` as const }
  return res
}

/**
 * @description Resolves channel and live video from station settings (with legacy youtubeChannelId fallback), optional body `liveVideoId`, and active live registry. `cueType` is always `cueTypeAd`.
 * @summary Insert an ad cuepoint for the station live broadcast
 * {@link /youtube-cuepoints/:station}
 */
export async function insertCuepointYoutubeIntegrationCuepoints(station: InsertCuepointYoutubeIntegrationCuepointsPathParams["station"], data: InsertCuepointYoutubeIntegrationCuepointsMutationRequest, config: Partial<RequestConfig<InsertCuepointYoutubeIntegrationCuepointsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<InsertCuepointYoutubeIntegrationCuepointsMutationResponse, ResponseErrorConfig<Error>, InsertCuepointYoutubeIntegrationCuepointsMutationRequest>({ method : "POST", url : getInsertCuepointYoutubeIntegrationCuepointsUrl(station).url.toString(), data : requestData, ... requestConfig })
  return res.data
}